import React, { useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import './ModulePage.css';
import { useLanguage } from '../contexts/LanguageContext';

const DEMO_STORY = `Un Viaje Inolvidable

El año pasado, Ana decidió viajar a México. Compró un boleto de avión y preparó su pasaporte. Al llegar al aeropuerto, tomó un taxi hasta su hotel en el centro de la ciudad. Después de registrarse, hizo una reservación en un restaurante famoso. Durante su viaje, usó el metro y el camión para explorar diferentes lugares. Un día, Ana se perdió y pidió ayuda a un amable "güey" local. Al final, pagó la cuenta en el hotel y agradeció a todos diciendo "gracias". ¡Fue una experiencia chida!`;

function DemoStoryPage() {
  const { t, isRTL } = useLanguage();
  const navigate = useNavigate();
  const [summary, setSummary] = useState('');
  const [showPremiumMsg, setShowPremiumMsg] = useState(false);
  const [evaluating, setEvaluating] = useState(false);
  const textareaRef = useRef(null);

  const handleSummaryChange = (e) => {
    setSummary(e.target.value);
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      textareaRef.current.style.height = textareaRef.current.scrollHeight + 'px';
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setEvaluating(true);
    setTimeout(() => {
      setShowPremiumMsg(true);
      setEvaluating(false);
    }, 900);
  };

  return (
    <div className="module-page-container" style={{ marginTop: '3.5rem' }}>
      <button onClick={() => navigate('/module/demo/group/0')} className="btn btn-secondary btn-back">
        {t('backToWordGroup')}
      </button>
      <div className="card learn-topic-card">
        <h2>{t('story') || 'Story'}: Viaje (Demo)</h2>
        <div
          style={{
            whiteSpace: 'pre-line',
            marginBottom: '1.5rem',
            fontSize: '1.1rem',
            color: '#222',
            textAlign: isRTL ? 'right' : 'left',
            direction: isRTL ? 'rtl' : 'ltr',
          }}
        >
          {DEMO_STORY}
        </div>
        {showPremiumMsg ? (
          <div style={{ marginTop: '2rem', textAlign: 'center' }}>
            <div className="card" style={{ background: '#fff4f4', color: '#b00', padding: '1.1rem', marginBottom: '1.5rem', fontWeight: 500, fontSize: '1.08rem' }}>
              {t('needPremiumForAIFeedback') || 'You need Premium to get AI feedback on your summary.'}
            </div>
            <button className="btn btn-primary" onClick={() => navigate('/module/demo/group/0')}>{t('backToWordGroup')}</button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} style={{ marginTop: '2rem' }}>
            <div className="form-group">
              <label htmlFor="summary"><strong>{t('writeSummary')}</strong></label>
              <textarea
                id="summary"
                value={summary}
                onChange={handleSummaryChange}
                className="form-control"
                disabled={evaluating}
                required
                ref={textareaRef}
                style={{overflow: 'hidden'}} />
            </div>
            <button type="submit" className="btn btn-primary" disabled={evaluating || !summary.trim()}>
              {evaluating ? t('evaluating') || 'Evaluating...' : t('submitSummary') || 'Submit Summary'}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}

export default DemoStoryPage; 